import React, { Suspense } from 'react';
import FunnelbackInstantSearch from './FunnelbackInstantSearch';
import FunnelbackInstantSearchLoadingState from './FunnelbackInstantSearchLoadingState';

/**
 * Initializer class, wrapping FunnelbackSearch component in suspense.
 */
export default class FunnelbackInstantSearchLoader {
    constructor(config) {
        this.config = this._parseConfiguration(config);
    }

    getComponent() {
        const component = <FunnelbackInstantSearch {...this.config} />;
        return <Suspense fallback={<FunnelbackInstantSearchLoadingState {...this.config} />}>{component}</Suspense>;
    }

    _parseConfiguration(config) {
        return {
            ...config,
        };
    }
}
